import n, { useState as i, useEffect as d } from "react";
import { Extras as f } from "./index190.mjs";
import u from "./index191.mjs";
import { EXTRA_SELECTION_HASH as c } from "./index87.mjs";
import { useTracking as h } from "./index88.mjs";
import { allocateGuestsAtom as x } from "./index34.mjs";
import { useSetAtom as g } from "jotai";
const H = ({
  cartItem: t,
  preFetchedExtras: m
}) => {
  h(c);
  const l = g(x), [o, r] = i(null), [e, A] = i(!1), [s, p] = i(!1);
  return d(() => {
    r(
      Math.max(
        t.maxOccupancy - Math.min(t.totalAdults, t.maxAdults),
        0
      )
    );
  }, [t.maxOccupancy, t.totalAdults, t.maxAdults]), d(() => {
    const a = t.id;
    e || (l({
      cartItemId: a,
      personType: "totalAdults",
      amount: Math.min(t.totalAdults, t.maxAdults)
    }), A(!0));
  }, [
    l,
    t.id,
    t.maxAdults,
    t.totalAdults,
    e
  ]), d(() => {
    const a = t.id;
    o !== null && !s && (l({
      cartItemId: a,
      personType: "totalChildren",
      amount: Math.min(t.totalChildren, o)
    }), p(!0));
  }, [
    l,
    t.id,
    t.totalChildren,
    o,
    s
  ]), /* @__PURE__ */ n.createElement("div", { className: u.single_room, "data-testid": "single-room-step" }, /* @__PURE__ */ n.createElement("div", { className: u.title, "data-testid": "single-room-title" }, I18n.t("booking_engine.information.upgrade_stay")), e && s ? /* @__PURE__ */ n.createElement(f, { cartItem: t, preFetchedExtras: m }) : null);
};
export {
  H as SingleRoomStep
};
